import Image from 'next/image';
import { CDN2 } from '@/helpers/api';

export default function Leadership() {
  return (
    <div className="w-full bg-white">
      <div className="mx-auto px-4 md:px-32 xl:px-4 space-y-6 max-w-7xl py-16">
        <h2 className="text-xl lg:text-3xl font-bold text-center">
          Meet Our Leadership
        </h2>
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0 gap-4">
          <div className="flex flex-col items-center text-center space-y-2 border rounded-md p-8 w-full">
            <Image
              src={CDN2() + '/staticmyapp/letter/patrick.png'}
              alt="Patrick Murray"
              width="120"
              height="120"
              className="rounded-full"
              quality={100}
            />
            <p className="text-base md:text-xl font-bold mt-4">
              PATRICK MURRAY
            </p>
            <p className="text-base md:text-xl">
              Chairman, Co-Founder
            </p>
          </div>
          <div className="flex flex-col items-center text-center space-y-2 border rounded-md p-8 w-full">
            <Image
              src={CDN2() + '/staticmyapp/letter/brett.jpg'}
              alt="Brett Harwood"
              width="120"
              height="120"
              className="rounded-full"
              quality={100}
            />
            <p className="text-base md:text-xl font-bold mt-4">
              BRETT HARWOOD
            </p>
            <p className="text-base md:text-xl">
              Co-Founder
            </p>
          </div>
          <div className="flex flex-col items-center text-center space-y-2 border rounded-md p-8 w-full">
            <Image
              src={CDN2() + '/staticmyapp/partnerus/carlos.webp'}
              alt="Carlos Chilin"
              width="120"
              height="120"
              className="rounded-full"
              quality={100}
            />
            <p className="text-base md:text-xl font-bold mt-4 uppercase">
              Carlos Chilin
            </p>
            <p className="text-base md:text-xl">
              CEO
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
